export default __webpack_public_path__ + "static/media/avatar_1.16b9c050.png";